// src/phoneCountryCodes.ts
function flagFromIso(iso2) {
  const codePoints = iso2.toUpperCase().split("").map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
var RAW_COUNTRIES = [
  // --- España y Europa ---
  ["+376", "AD", "Andorra"],
  ["+355", "AL", "Albania"],
  ["+43", "AT", "Austria"],
  ["+387", "BA", "Bosnia y Herzegovina"],
  ["+32", "BE", "B\xE9lgica"],
  ["+359", "BG", "Bulgaria"],
  ["+375", "BY", "Bielorrusia"],
  ["+41", "CH", "Suiza"],
  ["+357", "CY", "Chipre"],
  ["+420", "CZ", "Rep\xFAblica Checa"],
  ["+49", "DE", "Alemania"],
  ["+45", "DK", "Dinamarca"],
  ["+372", "EE", "Estonia"],
  ["+34", "ES", "Espa\xF1a"],
  ["+358", "FI", "Finlandia"],
  ["+298", "FO", "Islas Feroe"],
  ["+33", "FR", "Francia"],
  ["+44", "GB", "Reino Unido"],
  ["+350", "GI", "Gibraltar"],
  ["+30", "GR", "Grecia"],
  ["+385", "HR", "Croacia"],
  ["+36", "HU", "Hungr\xEDa"],
  ["+353", "IE", "Irlanda"],
  ["+354", "IS", "Islandia"],
  ["+39", "IT", "Italia"],
  ["+423", "LI", "Liechtenstein"],
  ["+370", "LT", "Lituania"],
  ["+352", "LU", "Luxemburgo"],
  ["+371", "LV", "Letonia"],
  ["+377", "MC", "M\xF3naco"],
  ["+373", "MD", "Moldavia"],
  ["+382", "ME", "Montenegro"],
  ["+389", "MK", "Macedonia del Norte"],
  ["+356", "MT", "Malta"],
  ["+31", "NL", "Pa\xEDses Bajos"],
  ["+47", "NO", "Noruega"],
  ["+48", "PL", "Polonia"],
  ["+351", "PT", "Portugal"],
  ["+40", "RO", "Ruman\xEDa"],
  ["+381", "RS", "Serbia"],
  ["+7", "RU", "Rusia"],
  ["+46", "SE", "Suecia"],
  ["+386", "SI", "Eslovenia"],
  ["+421", "SK", "Eslovaquia"],
  ["+378", "SM", "San Marino"],
  ["+380", "UA", "Ucrania"],
  ["+379", "VA", "Ciudad del Vaticano"],
  ["+383", "XK", "Kosovo"],
  // --- América del Norte ---
  ["+1", "US", "Estados Unidos"],
  ["+1", "CA", "Canad\xE1"],
  ["+52", "MX", "M\xE9xico"],
  ["+299", "GL", "Groenlandia"],
  ["+508", "PM", "San Pedro y Miquel\xF3n"],
  // --- América Central ---
  ["+501", "BZ", "Belice"],
  ["+506", "CR", "Costa Rica"],
  ["+503", "SV", "El Salvador"],
  ["+502", "GT", "Guatemala"],
  ["+504", "HN", "Honduras"],
  ["+505", "NI", "Nicaragua"],
  ["+507", "PA", "Panam\xE1"],
  // --- Caribe ---
  ["+1268", "AG", "Antigua y Barbuda"],
  ["+1264", "AI", "Anguila"],
  ["+297", "AW", "Aruba"],
  ["+1242", "BS", "Bahamas"],
  ["+1246", "BB", "Barbados"],
  ["+599", "BQ", "Bonaire, San Eustaquio y Saba"],
  ["+590", "BL", "San Bartolom\xE9"],
  ["+53", "CU", "Cuba"],
  ["+599", "CW", "Curazao"],
  ["+1767", "DM", "Dominica"],
  ["+1", "DO", "Rep\xFAblica Dominicana"],
  ["+1473", "GD", "Granada"],
  ["+590", "GP", "Guadalupe"],
  ["+509", "HT", "Hait\xED"],
  ["+1876", "JM", "Jamaica"],
  ["+1345", "KY", "Islas Caim\xE1n"],
  ["+1869", "KN", "San Crist\xF3bal y Nieves"],
  ["+1758", "LC", "Santa Luc\xEDa"],
  ["+590", "MF", "San Mart\xEDn"],
  ["+596", "MQ", "Martinica"],
  ["+1664", "MS", "Montserrat"],
  ["+1", "PR", "Puerto Rico"],
  ["+1721", "SX", "Sint Maarten"],
  ["+1649", "TC", "Islas Turcas y Caicos"],
  ["+1868", "TT", "Trinidad y Tobago"],
  ["+1784", "VC", "San Vicente y las Granadinas"],
  ["+1284", "VG", "Islas V\xEDrgenes Brit\xE1nicas"],
  ["+1340", "VI", "Islas V\xEDrgenes de EE. UU."],
  // --- América del Sur ---
  ["+54", "AR", "Argentina"],
  ["+591", "BO", "Bolivia"],
  ["+55", "BR", "Brasil"],
  ["+56", "CL", "Chile"],
  ["+57", "CO", "Colombia"],
  ["+593", "EC", "Ecuador"],
  ["+500", "FK", "Islas Malvinas"],
  ["+594", "GF", "Guayana Francesa"],
  ["+592", "GY", "Guyana"],
  ["+595", "PY", "Paraguay"],
  ["+51", "PE", "Per\xFA"],
  ["+597", "SR", "Surinam"],
  ["+598", "UY", "Uruguay"],
  ["+58", "VE", "Venezuela"],
  // --- Asia ---
  ["+93", "AF", "Afganist\xE1n"],
  ["+374", "AM", "Armenia"],
  ["+994", "AZ", "Azerbaiy\xE1n"],
  ["+973", "BH", "Bar\xE9in"],
  ["+880", "BD", "Banglad\xE9s"],
  ["+975", "BT", "But\xE1n"],
  ["+673", "BN", "Brun\xE9i"],
  ["+855", "KH", "Camboya"],
  ["+86", "CN", "China"],
  ["+995", "GE", "Georgia"],
  ["+852", "HK", "Hong Kong"],
  ["+91", "IN", "India"],
  ["+62", "ID", "Indonesia"],
  ["+98", "IR", "Ir\xE1n"],
  ["+964", "IQ", "Irak"],
  ["+972", "IL", "Israel"],
  ["+81", "JP", "Jap\xF3n"],
  ["+962", "JO", "Jordania"],
  ["+7", "KZ", "Kazajist\xE1n"],
  ["+850", "KP", "Corea del Norte"],
  ["+82", "KR", "Corea del Sur"],
  ["+965", "KW", "Kuwait"],
  ["+996", "KG", "Kirguist\xE1n"],
  ["+856", "LA", "Laos"],
  ["+961", "LB", "L\xEDbano"],
  ["+853", "MO", "Macao"],
  ["+60", "MY", "Malasia"],
  ["+960", "MV", "Maldivas"],
  ["+976", "MN", "Mongolia"],
  ["+95", "MM", "Birmania"],
  ["+977", "NP", "Nepal"],
  ["+968", "OM", "Om\xE1n"],
  ["+92", "PK", "Pakist\xE1n"],
  ["+970", "PS", "Palestina"],
  ["+63", "PH", "Filipinas"],
  ["+974", "QA", "Catar"],
  ["+966", "SA", "Arabia Saudita"],
  ["+65", "SG", "Singapur"],
  ["+94", "LK", "Sri Lanka"],
  ["+963", "SY", "Siria"],
  ["+886", "TW", "Taiw\xE1n"],
  ["+992", "TJ", "Tayikist\xE1n"],
  ["+66", "TH", "Tailandia"],
  ["+670", "TL", "Timor Oriental"],
  ["+90", "TR", "Turqu\xEDa"],
  ["+993", "TM", "Turkmenist\xE1n"],
  ["+971", "AE", "Emiratos \xC1rabes Unidos"],
  ["+998", "UZ", "Uzbekist\xE1n"],
  ["+84", "VN", "Vietnam"],
  ["+967", "YE", "Yemen"],
  // --- África ---
  ["+213", "DZ", "Argelia"],
  ["+244", "AO", "Angola"],
  ["+229", "BJ", "Ben\xEDn"],
  ["+267", "BW", "Botsuana"],
  ["+226", "BF", "Burkina Faso"],
  ["+257", "BI", "Burundi"],
  ["+238", "CV", "Cabo Verde"],
  ["+237", "CM", "Camer\xFAn"],
  ["+236", "CF", "Rep\xFAblica Centroafricana"],
  ["+235", "TD", "Chad"],
  ["+269", "KM", "Comoras"],
  ["+243", "CD", "Rep\xFAblica Democr\xE1tica del Congo"],
  ["+242", "CG", "Rep\xFAblica del Congo"],
  ["+225", "CI", "Costa de Marfil"],
  ["+253", "DJ", "Yibuti"],
  ["+20", "EG", "Egipto"],
  ["+240", "GQ", "Guinea Ecuatorial"],
  ["+291", "ER", "Eritrea"],
  ["+268", "SZ", "Esuatini"],
  ["+251", "ET", "Etiop\xEDa"],
  ["+241", "GA", "Gab\xF3n"],
  ["+220", "GM", "Gambia"],
  ["+233", "GH", "Ghana"],
  ["+224", "GN", "Guinea"],
  ["+245", "GW", "Guinea-Bis\xE1u"],
  ["+254", "KE", "Kenia"],
  ["+266", "LS", "Lesoto"],
  ["+231", "LR", "Liberia"],
  ["+218", "LY", "Libia"],
  ["+261", "MG", "Madagascar"],
  ["+265", "MW", "Malaui"],
  ["+223", "ML", "Mal\xED"],
  ["+222", "MR", "Mauritania"],
  ["+230", "MU", "Mauricio"],
  ["+262", "YT", "Mayotte"],
  ["+212", "MA", "Marruecos"],
  ["+258", "MZ", "Mozambique"],
  ["+264", "NA", "Namibia"],
  ["+227", "NE", "N\xEDger"],
  ["+234", "NG", "Nigeria"],
  ["+250", "RW", "Ruanda"],
  ["+262", "RE", "Reuni\xF3n"],
  ["+239", "ST", "Santo Tom\xE9 y Pr\xEDncipe"],
  ["+221", "SN", "Senegal"],
  ["+248", "SC", "Seychelles"],
  ["+232", "SL", "Sierra Leona"],
  ["+252", "SO", "Somalia"],
  ["+27", "ZA", "Sud\xE1frica"],
  ["+211", "SS", "Sud\xE1n del Sur"],
  ["+249", "SD", "Sud\xE1n"],
  ["+255", "TZ", "Tanzania"],
  ["+228", "TG", "Togo"],
  ["+216", "TN", "T\xFAnez"],
  ["+256", "UG", "Uganda"],
  ["+260", "ZM", "Zambia"],
  ["+263", "ZW", "Zimbabue"],
  ["+290", "SH", "Santa Elena"],
  // --- Oceanía ---
  ["+61", "AU", "Australia"],
  ["+682", "CK", "Islas Cook"],
  ["+679", "FJ", "Fiyi"],
  ["+689", "PF", "Polinesia Francesa"],
  ["+1671", "GU", "Guam"],
  ["+686", "KI", "Kiribati"],
  ["+692", "MH", "Islas Marshall"],
  ["+691", "FM", "Micronesia"],
  ["+674", "NR", "Nauru"],
  ["+687", "NC", "Nueva Caledonia"],
  ["+64", "NZ", "Nueva Zelanda"],
  ["+683", "NU", "Niue"],
  ["+672", "NF", "Isla Norfolk"],
  ["+1670", "MP", "Islas Marianas del Norte"],
  ["+680", "PW", "Palaos"],
  ["+675", "PG", "Pap\xFAa Nueva Guinea"],
  ["+685", "WS", "Samoa"],
  ["+1684", "AS", "Samoa Americana"],
  ["+677", "SB", "Islas Salom\xF3n"],
  ["+690", "TK", "Tokelau"],
  ["+676", "TO", "Tonga"],
  ["+688", "TV", "Tuvalu"],
  ["+678", "VU", "Vanuatu"],
  ["+681", "WF", "Wallis y Futuna"]
];
var COUNTRIES = RAW_COUNTRIES.map(
  ([code, iso, name]) => ({ code, iso, flag: flagFromIso(iso), name })
);
var COUNTRIES_BY_ISO = new Map(
  COUNTRIES.map((c) => [c.iso, c])
);
var FRECUENTES_ISO = [
  "ES",
  "MX",
  "AR",
  "CO",
  "PE",
  "CL",
  "VE",
  "EC",
  "GT",
  "CU",
  "BO",
  "DO",
  "HN",
  "PY",
  "SV",
  "NI",
  "CR",
  "PA",
  "UY",
  "GQ",
  "PR",
  "PT",
  "FR",
  "DE",
  "IT",
  "GB",
  "NL",
  "BE",
  "CH"
];
function getOrderedCountries(defaultCode) {
  const used = /* @__PURE__ */ new Set();
  const ordered = [];
  if (defaultCode) {
    const def = COUNTRIES.find((c) => c.code === defaultCode);
    if (def) {
      ordered.push(def);
      used.add(def.iso);
    }
  }
  for (const iso of FRECUENTES_ISO) {
    if (used.has(iso)) continue;
    const c = COUNTRIES_BY_ISO.get(iso);
    if (c) {
      ordered.push(c);
      used.add(iso);
    }
  }
  const resto = [...COUNTRIES].filter((c) => !used.has(c.iso)).sort((a, b) => a.name.localeCompare(b.name, "es"));
  return [...ordered, ...resto];
}
var TIMEZONE_COUNTRY_CODE = {
  // España
  "Europe/Madrid": "+34",
  "Africa/Ceuta": "+34",
  "Atlantic/Canary": "+34",
  // México (todas las zonas IANA reales, no solo Ciudad de México)
  "America/Mexico_City": "+52",
  "America/Cancun": "+52",
  "America/Merida": "+52",
  "America/Monterrey": "+52",
  "America/Matamoros": "+52",
  "America/Tijuana": "+52",
  "America/Hermosillo": "+52",
  "America/Chihuahua": "+52",
  "America/Ciudad_Juarez": "+52",
  "America/Mazatlan": "+52",
  "America/Bahia_Banderas": "+52",
  "America/Ojinaga": "+52",
  // Argentina (todas las zonas IANA reales + alias antiguos)
  "America/Argentina/Buenos_Aires": "+54",
  "America/Argentina/Cordoba": "+54",
  "America/Argentina/Salta": "+54",
  "America/Argentina/Jujuy": "+54",
  "America/Argentina/Tucuman": "+54",
  "America/Argentina/Catamarca": "+54",
  "America/Argentina/La_Rioja": "+54",
  "America/Argentina/San_Juan": "+54",
  "America/Argentina/Mendoza": "+54",
  "America/Argentina/San_Luis": "+54",
  "America/Argentina/Rio_Gallegos": "+54",
  "America/Argentina/Ushuaia": "+54",
  "America/Buenos_Aires": "+54",
  "America/Cordoba": "+54",
  "America/Mendoza": "+54",
  // Colombia
  "America/Bogota": "+57",
  // Perú
  "America/Lima": "+51",
  // Chile
  "America/Santiago": "+56",
  "America/Punta_Arenas": "+56",
  "Pacific/Easter": "+56",
  // Venezuela
  "America/Caracas": "+58",
  // Ecuador
  "America/Guayaquil": "+593",
  "Pacific/Galapagos": "+593",
  // Bolivia
  "America/La_Paz": "+591",
  // Paraguay
  "America/Asuncion": "+595",
  // Uruguay
  "America/Montevideo": "+598",
  // Guatemala
  "America/Guatemala": "+502",
  // El Salvador
  "America/El_Salvador": "+503",
  // Honduras
  "America/Tegucigalpa": "+504",
  // Nicaragua
  "America/Managua": "+505",
  // Costa Rica
  "America/Costa_Rica": "+506",
  // Panamá
  "America/Panama": "+507",
  // Cuba
  "America/Havana": "+53",
  // República Dominicana
  "America/Santo_Domingo": "+1",
  // Puerto Rico
  "America/Puerto_Rico": "+1",
  // Guinea Ecuatorial (único país hispanohablante en África)
  "Africa/Malabo": "+240",
  // Portugal
  "Europe/Lisbon": "+351",
  "Atlantic/Madeira": "+351",
  "Atlantic/Azores": "+351",
  // Reino Unido
  "Europe/London": "+44",
  // Otros europeos frecuentes
  "Europe/Paris": "+33",
  "Europe/Berlin": "+49",
  "Europe/Rome": "+39",
  "Europe/Amsterdam": "+31",
  "Europe/Brussels": "+32",
  "Europe/Zurich": "+41"
};
function defaultCountryCodeForTimezone(timezone) {
  if (!timezone) return "+34";
  return TIMEZONE_COUNTRY_CODE[timezone] || "+34";
}

// src/index.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["SUPER_ADMIN"] = "SUPER_ADMIN";
  UserRole2["ADMIN"] = "ADMIN";
  UserRole2["MANAGER"] = "MANAGER";
  UserRole2["STAFF"] = "STAFF";
  return UserRole2;
})(UserRole || {});
var SubscriptionPlan = /* @__PURE__ */ ((SubscriptionPlan2) => {
  SubscriptionPlan2["FREE"] = "FREE";
  SubscriptionPlan2["BASIC"] = "BASIC";
  SubscriptionPlan2["PRO"] = "PRO";
  SubscriptionPlan2["ENTERPRISE"] = "ENTERPRISE";
  return SubscriptionPlan2;
})(SubscriptionPlan || {});
var OrganizationStatus = /* @__PURE__ */ ((OrganizationStatus2) => {
  OrganizationStatus2["ACTIVE"] = "ACTIVE";
  OrganizationStatus2["SUSPENDED"] = "SUSPENDED";
  OrganizationStatus2["TRIAL"] = "TRIAL";
  return OrganizationStatus2;
})(OrganizationStatus || {});
var ReservationStatus = /* @__PURE__ */ ((ReservationStatus2) => {
  ReservationStatus2["PENDING"] = "PENDING";
  ReservationStatus2["CONFIRMED"] = "CONFIRMED";
  ReservationStatus2["SEATED"] = "SEATED";
  ReservationStatus2["COMPLETED"] = "COMPLETED";
  ReservationStatus2["CANCELLED"] = "CANCELLED";
  ReservationStatus2["NO_SHOW"] = "NO_SHOW";
  return ReservationStatus2;
})(ReservationStatus || {});
var TableStatus = /* @__PURE__ */ ((TableStatus2) => {
  TableStatus2["AVAILABLE"] = "AVAILABLE";
  TableStatus2["OCCUPIED"] = "OCCUPIED";
  TableStatus2["RESERVED"] = "RESERVED";
  TableStatus2["UNAVAILABLE"] = "UNAVAILABLE";
  return TableStatus2;
})(TableStatus || {});
export {
  COUNTRIES,
  OrganizationStatus,
  ReservationStatus,
  SubscriptionPlan,
  TableStatus,
  UserRole,
  defaultCountryCodeForTimezone,
  flagFromIso,
  getOrderedCountries
};
